import { render } from "./blague.vue?vue&type=template&id=085dd628&scoped=true"
import script from "./blague.vue?vue&type=script&lang=js"
export * from "./blague.vue?vue&type=script&lang=js"

import "./blague.vue?vue&type=style&index=0&id=085dd628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085dd628"]])

export default __exports__